import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";

const QUESTIONS = [
  {
    q: "Como faço para reservar?",
    a: "A reserva é feita diretamente pelo WhatsApp. Após definir a experiência, data e condições, será informado o valor do sinal. O passeio será considerado reservado após a confirmação do pagamento.",
  },
  {
    q: "Quais formas de pagamento são aceitas?",
    a: "Pix, cartão de crédito, débito, link de pagamento e cartão por aproximação (NFC). No crédito, há possibilidade de parcelamento em até 3x, sujeito às taxas administrativas da operadora quando aplicáveis.",
  },
  {
    q: "O transporte está incluído?",
    a: "Sim. Em todos os passeios do catálogo, o transfer de ida e volta da sua hospedagem está incluído. Se preferir descer em outro ponto ao final, combinamos pelo WhatsApp na hora da reserva.",
  },
  {
    q: "Os ingressos estão incluídos?",
    a: "Sim. Os ingressos estão incluídos nos passeios do catálogo: Cristo Redentor com subida de van e Pão de Açúcar com bondinho, conforme o roteiro escolhido.",
  },
  {
    q: "Posso sugerir outro lugar?",
    a: "Sim. Você pode sugerir um lugar pelo WhatsApp e vamos avaliar a possibilidade de incluí-lo em um roteiro personalizado, considerando tempo, deslocamento e disponibilidade.",
  },
  {
    q: "Os horários são fixos?",
    a: "Não necessariamente. Os horários são definidos de acordo com o passeio escolhido, a época do ano, o deslocamento e as condições do dia — e são sempre confirmados na reserva.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="scroll-mt-24 border-t border-white/10 bg-[#161B22]">
      <div className="mx-auto max-w-4xl px-5 py-24 sm:px-8 sm:py-32">
        <Reveal className="text-center">
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
            Perguntas frequentes
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl lg:text-5xl">
            Tudo o que você precisa{" "}
            <em className="font-accent font-medium italic text-amber-400">saber.</em>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-14">
            {QUESTIONS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-accordion-item-${i}`}
                className="border-white/10"
              >
                <AccordionTrigger className="text-left font-display text-base font-bold text-stone-100 hover:text-amber-400 hover:no-underline sm:text-lg">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-stone-400 sm:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
